export default __webpack_public_path__ + "static/media/flightUpIcon.ce4ccd23.svg";